module.exports = __webpack_public_path__ + "img/ai-inter.bb258d2c.svg";